import {Stack, Typography, useTheme} from '@mui/material';
import React from 'react';

import Icon from 'presentation/icons';
import {formatText} from 'presentation/utils';
import {TagChip} from 'presentation/components';
import {translations} from 'presentation/translations-new';

import {StyledContainer} from './styles';
import {HealthHeaderSectionProps} from './types';
import {QualificationList} from 'presentation/modules/guide/shared/ui/components';

const {referenceNetwork} = translations['pt-br'].commons;

export function HealthHeaderSection({provider, showTradeName}: HealthHeaderSectionProps) {
	const theme = useTheme();
	const providerName =
		showTradeName && provider?.nmFantasia ? provider?.nmFantasia : provider?.nmLocal || '-';

	return (
		<StyledContainer>
			<Stack direction={'column'} justifyContent="space-between">
				{provider?.ordemRR ? (
					<TagChip
						label={
							<Stack direction="row" alignItems="center" gap={0.5}>
								{referenceNetwork}
								<Icon
									name={'location-on-filled'}
									size={20}
									color={theme.palette.secondary.main}
								/>
							</Stack>
						}
						color="success"
						sx={{
							width: 'fit-content',
							fontSize: '0.75rem',
							borderRadius: '4px',
							marginBottom: provider?.qualificacoes?.length > 0 ? 0 : 0.5,
						}}
					/>
				) : null}
				{provider?.qualificacoes?.length > 0 ? (
					<QualificationList qualifications={provider.qualificacoes} isInverse />
				) : null}
				<Typography variant="h6" color="primary">
					{formatText(providerName)}
				</Typography>
			</Stack>
		</StyledContainer>
	);
}
